import {cdnImage} from '@/util/cdnImage';
const react = cdnImage('Asset-tokenization/binance-smart-chain.svg');
const IT = cdnImage('contact-us/it.svg');
const continents = cdnImage('contact-us/continents.svg');
const success = cdnImage('contact-us/success.svg');
const team = cdnImage('contact-us/team.svg');
const aws = cdnImage('contact-us/aws.svg');
const oracle = cdnImage('contact-us/oracle.svg');
const micrososft = cdnImage('contact-us/microsoft.svg');
export const contactCardData = [
    {
        icon: IT,
        heading: '15+ years in IT',
        tagline: 'to deliver value that lasts'
    },
    {
        icon: success,
        heading: 'Over 500 success stories',
        tagline: 'including Disney, KFC, DocuSign & HDFC Bank'
    },
    {
        icon: team,
        heading: 'Team of 150 specialists',
        tagline: 'Web, mobile, Blockchain, AI & ML'
    },
    {
        icon: continents,
        heading: 'Presence across 5 continents',
        tagline: 'Get Dedicated Account Managers operating in your time-zone.'
    }
];
export const contactSideImages = [
    {img: aws, alt: 'AWS'},
    {img: oracle, alt: 'Oracle'},
    {img: micrososft, alt: 'Microsoft'}
];

export const contactButton = [
    {
        icon: react,
        label: 'Call us'
    },
    {
        icon: react,
        label: 'Live chat'
    },
    {
        icon: react,
        label: 'Whatsapp'
    },
    {
        icon: react,
        label: 'Email us'
    }
];

export const SCRIPT_PREVENTION = ['script', 'http', 'www', 'https', '<'];

// ─── Project-brief section (redesigned "common form" above the footer) ─────────
// Left column intro copy + trust points. Icons are keys resolved to MUI icons in
// the layout so no new SVG assets are needed for the light-background column.
export const projectBriefContent = {
    eyebrow: "LET'S WORK TOGETHER",
    headingLine1: 'Your Vision.',
    headingLine2: 'Our Engineering.',
    description:
        'Debut Infotech works as a strategic co-creator — from concept to production-ready platform. We deliver blockchain, AI, enterprise, & mobile solutions that scale.',
    phone: {label: '+1 708-515-4004 (USA)', href: 'tel:1-708-515-4004'},
    email: {label: 'info@debutinfotech.com', href: 'mailto:info@debutinfotech.com'}
};

export const projectBriefFeatures = [
    {
        icon: 'award',
        heading: '15+ Years · 500+ Platforms Delivered',
        tagline: 'Across blockchain, AI, fintech, mobile, and enterprise verticals'
    },
    {
        icon: 'lock',
        heading: 'NDA Signed on Day One',
        tagline: 'Your IP and project details are protected before any conversation begins'
    },
    {
        icon: 'bolt',
        heading: '48-Hour Scoped Estimate',
        tagline: 'A real technical estimate — not a generic template or sales pitch'
    },
    {
        icon: 'team',
        heading: 'Dedicated Account Managers',
        tagline: 'Available across key global time zones'
    }
];

export const trustBadges = ['NDA Protected', '48hr Response', 'No Spam'];

// Budget options for the project-brief form — same tiers as `contactBudget`, but the
// empty option's label acts as the select placeholder ("Approximate budget").
export const budgetOptions = [
    {value: '', label: 'Approximate budget'},
    {value: '$10,000 - $15,000', label: '$10,000 - $15,000'},
    {value: '$15,000 - $25,000', label: '$15,000 - $25,000'},
    {value: '$25,000+', label: '$25,000+'}
];

export const serviceOptions = [
    {value: '', label: 'What are you building?'},
    {value: 'Web Development', label: 'Web Development'},
    {value: 'Mobile App Development', label: 'Mobile App Development'},
    {value: 'Blockchain Development', label: 'Blockchain Development'},
    {value: 'AI / ML Development', label: 'AI / ML Development'},
    {value: 'Enterprise Software', label: 'Enterprise Software'},
    {value: 'Other', label: 'Other'}
];

export const startDateOptions = [
    {value: '', label: 'When to begin?'},
    {value: 'Immediately', label: 'Immediately'},
    {value: 'In 1 month', label: 'In 1 month'},
    {value: 'In 2-3 months', label: 'In 2-3 months'},
    {value: 'Just exploring', label: 'Just exploring'}
];

export const sourceOptions = [
    {value: '', label: 'Source (optional)'},
    {value: 'Google Search', label: 'Google Search'},
    {value: 'Referral', label: 'Referral'},
    {value: 'Social Media', label: 'Social Media'},
    {value: 'Clutch / GoodFirms', label: 'Clutch / GoodFirms'},
    {value: 'Other', label: 'Other'}
];

// ─── Contact-us page form (two-panel design, distinct from the site-wide form) ──
export const contactHeroContent = {
    headingParts: [
        {text: 'Build Your ', highlight: false},
        {text: 'Next Digital Product ', highlight: true},
        {text: 'With Confidence', highlight: false}
    ],
    description:
        'Partner with Debut Infotech for AI, blockchain, mobile, and custom software solutions built for scale, security, and business growth.',
    trustedLabel: 'TRUSTED BY GLOBAL BRANDS',
    formHeading: 'Start Your Project',
    formSubtext: "Share your requirements — we'll review and reply with a scoped estimate within 48 hours.",
    infoBar: {lead: 'Fast 48-hour response', strong: 'Fully NDA-protected'}
};

export const contactRatings = [
    {img: cdnImage('contact-us-forms/clutch-badge.webp'), alt: 'Reviewed on Clutch'},
    {img: cdnImage('contact-us-forms/goodfirms-developer-badge.webp'), alt: 'Rated 4.8 on GoodFirms'},
    {img: cdnImage('contact-us-forms/top-developer-badge.webp'), alt: 'Rated 4.9 on Top Developers'}
];

const brandLogo1 = cdnImage('inactive-form/logo1.webp');
const brandLogo2 = cdnImage('inactive-form/logo2.webp');
const brandLogo3 = cdnImage('inactive-form/logo3.webp');
const brandLogo4 = cdnImage('inactive-form/logo4.webp');
const brandLogo5 = cdnImage('inactive-form/logo5.webp');
export const contactBrandLogos = [
    {img: brandLogo1, alt: 'Client brand'},
    {img: brandLogo2, alt: 'Client brand'},
    {img: brandLogo3, alt: 'Client brand'},
    {img: brandLogo4, alt: 'Client brand'},
    {img: brandLogo5, alt: 'Client brand'}
];

// Same value lists as the site-wide form, page-specific placeholder labels.
export const contactPageServiceOptions = [
    {value: '', label: 'Select Services'},
    {value: 'Web Development', label: 'Web Development'},
    {value: 'Mobile App Development', label: 'Mobile App Development'},
    {value: 'Blockchain Development', label: 'Blockchain Development'},
    {value: 'AI / ML Development', label: 'AI / ML Development'},
    {value: 'Enterprise Software', label: 'Enterprise Software'},
    {value: 'Other', label: 'Other'}
];

export const contactPageBudgetOptions = [
    {value: '', label: 'Select a Budget Range'},
    {value: '$10,000 - $15,000', label: '$10,000 - $15,000'},
    {value: '$15,000 - $25,000', label: '$15,000 - $25,000'},
    {value: '$25,000+', label: '$25,000+'}
];

export const contactBudget = [
    {
        value: '',
        label: 'Select Budget*'
    },
    {
        value: '$10,000 - $15,000',
        label: '$10,000 - $15,000'
    },
    {
        value: '$15,000 - $25,000',
        label: '$15,000 - $25,000'
    },
    {
        value: '$25,000+',
        label: '$25,000+'
    }
];
export const mainBudget = [
    {
        value: '',
        label: 'Select Budget*'
    },
    {
        value: '$10,000 - $15,000',
        label: '$10,000 - $15,000'
    },
    {
        value: '$15,000 - $25,000',
        label: '$15,000 - $25,000'
    },
    {
        value: '$25,000+',
        label: '$25,000+'
    }
];

export interface LoginForm {
    fullName: string;
    email: string;
    phone_number: string;
    country_code: string;
    about: string;
    budget: string;
    serviceNeeded: string;
    startDate: string;
    source: string;
    captcha: boolean;
}

const client = cdnImage('android/Client-Centric-Development.webp');
const dataBackup = cdnImage('android/Data-Backup-Protection.webp');
const highQuality = cdnImage('android/High-Quality-Assurance.webp');
const fullSupport = cdnImage('android/24-7-Support.webp');
export const contactStepData = [
    {
        redirect: '',
        src: client,
        heading: 'Client-Centric Development',
        body: `We are committed to providing customer-focused blockchain, web, and mobile solutions with top-notch quality, quicker deployment, and minimal cost.`
    },
    {
        redirect: '',
        src: dataBackup,
        heading: 'Data Backup & Protection',
        body: `We take regular backups of all our clients’ data and securely store it on our dedicated servers to prevent any major data loss during a security incident.`
    },
    {
        redirect: '',
        src: highQuality,
        heading: 'High-Quality Assurance',
        body: `Delivering quality products and services to end-users is our top priority and we leave absolutely no stone unturned in our effort to ensure that.`
    },
    {
        redirect: '',
        src: fullSupport,
        heading: '24*7 Support',
        body: `Our highly-trained and well-armed technical experts work directly with you, offering 24*7 support for all our products and services via live chat, email, and phone.`
    }
];
